import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	derivatives: {
		pools: null,
		account: null
	}
});
